import { COOKIE_OAUTH_STATE_KEY } from '@/shared/utils/constants';
import { v4 as uuidv4 } from 'uuid';
import { setStorageItem } from './storage';
import env from '@beam-australia/react-env';

export const getOAuthAuthorizeUrl = () => {
  const path = 'api/v2/oauth/authorize';
  const authBaseUrl = env('OAUTH_BASE_URL');
  const clientId = env('OAUTH_CLIENT_ID');
  const oAuthStateParam = uuidv4().replace(/-/g, '');
  const redirectUri = env('OAUTH_REDIRECT_URI');

  setStorageItem(COOKIE_OAUTH_STATE_KEY, oAuthStateParam);

  return `${authBaseUrl}/${path}/?caas=true&response_type=code&client_id=${clientId}&state=${oAuthStateParam}&redirect_uri=${redirectUri}`;
};
